export default "__VITE_ASSET__BDXLYMWJ__"